export const FAQ_DATA = [
  {
    id: 'one',
    question: 'How does your service work?',
    answer: `All of our flights can be found by using the search tool on our website. Once you determine your flight and price details,
                                    you can either call us or fill out an email request form online. You will then be assigned
                                    a personal travel concierge who will send you the top three options and discuss these
                                    with you to assist in making the best decision for your travel needs.`,
  },
  {
    id: 'two',
    question: 'Can I book online?',
    answer: `Due to our contracts to acquire discounted fares, we cannot offer online booking. However, we guarantee that our exemplary
                                    personal service will make the experience more enjoyable and convenient for you.`,
  },
  {
    id: 'three',
    question: 'How do you offer such low fares?',
    answer: `We have negotiated contracts with major consolidators and wholesalers which enables us to offer deep discounts which are
                                    not available directly through the airlines or other travel websites.`,
  },
  {
    id: 'four',
    question: 'Can I change/cancel my tickets?',
    answer: `Absolutely! Almost every ticket that is booked at Wholesale Flights can be canceled or changed with no additional fees from
                                    us. In the rare circumstances where a flight cannot be canceled or changed, you will
                                    be notified before booking your flight.`,
  },
  {
    id: 'five',
    question: 'Can I accrue mileage?',
    answer: `Of course! We never keep any of your mileage. There are very occasionally super discounted flights that are not eligible
                                    for mileage, but in those instances you will be notified in advance.`,
  },
  {
    id: 'six',
    question: 'How does your price guarantee work?',
    answer: `We are so confident in our prices that if you provide us with the same schedule within 24 hours of your booking, including 
                        the fare basis and booking class, we will provide a travel voucher for the difference plus take an additional 
                        $200 off your next purchase.`,
  },
  {
    id: 'seven',
    question: 'Why can\'t I see the full flight details after a search?',
    answer: `Our contracts with the airlines do not allow us to display the full itinerary and brand identity of the carrier online. Your
                                    personal travel concierge will provide you with this information when you contact us
                                    or you can choose to receive it via email by filling out a request form online.`,
  }
];
